import { TemplateId } from '@cibli/shared';

import type { RegisteredTemplate } from '../types';

import ClassicDisplay from './Display';
import ClassicEditPannel from './EditPannel';
import { classicDefaultParams, classicParamsSchema } from './schema';

const classicTemplate: RegisteredTemplate<typeof classicDefaultParams> = {
  meta: {
    id: 'classic' as TemplateId,
    name: 'Classique',
  },
  schema: classicParamsSchema,
  defaults: classicDefaultParams,
  Display: ClassicDisplay as unknown as RegisteredTemplate<typeof classicDefaultParams>['Display'],
  EditPannel: ClassicEditPannel as unknown as RegisteredTemplate<
    typeof classicDefaultParams
  >['EditPannel'],
  pdfOptions: {
    printBackground: true,
  },
};

export default classicTemplate;
